// Parcelamento no cartão (2026-11-02, regra do dono): parcela mínima de
// R$ 50,00, até 12x. Ex.: R$ 150,00 -> no máximo 3x de R$ 50,00. Sem juros
// (o total no cartão não muda com o número de parcelas). Usado pelo
// checkout (opções de parcela), pelo servidor (recusa parcela acima do
// permitido) e pela página do produto (o "ou Nx de" mostrado).

export const MIN_INSTALLMENT_VALUE_MINOR = 5_000;
export const MAX_CARD_INSTALLMENTS = 12;
/** Até aqui sem juros; 11x e 12x com juros (2026-11-02, decisão do dono). */
export const INTEREST_FREE_INSTALLMENTS = 10;
/** 1,5% por parcela a partir da 11ª, em pontos-base. */
export const INTEREST_BPS_PER_EXTRA_INSTALLMENT = 150;

/**
 * Juros do parcelamento (centavos), calculados "por dentro":
 * total = valor / (1 - 1,5% x (parcelas - 10)), arredondado para cima no
 * centavo. R$ 1.000,00 -> 11x: R$ 1.015,23 (juros 15,23); 12x: R$ 1.030,93.
 * Mesma conta de public.native_card_interest_minor (migration
 * 20261102060000) -- o banco é a autoridade do valor cobrado.
 */
export function cardInterestMinor(baseMinor: number, installments: number | null | undefined): number {
  if (!Number.isSafeInteger(baseMinor) || baseMinor <= 0) return 0;
  if (!installments || installments <= INTEREST_FREE_INSTALLMENTS || installments > MAX_CARD_INSTALLMENTS) return 0;
  const denominator = 10_000 - INTEREST_BPS_PER_EXTRA_INSTALLMENT * (installments - INTEREST_FREE_INSTALLMENTS);
  const total = Math.floor((baseMinor * 10_000 + denominator - 1) / denominator);
  return total - baseMinor;
}

/** Máximo de parcelas para um total em centavos (sempre pelo menos 1). */
export function maxCardInstallments(totalMinor: number, cap: number = MAX_CARD_INSTALLMENTS): number {
  if (!Number.isFinite(totalMinor) || totalMinor <= 0) return 1;
  return Math.max(1, Math.min(cap, Math.floor(totalMinor / MIN_INSTALLMENT_VALUE_MINOR)));
}
